import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/utils/index-of';
import __var_2__ from './symbols.json';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var indexOf = __var_1__;
var SYMBOLS = __var_2__;


// VARIABLES //

var debug = logger( 'symbols:set:symbol' );


// MAIN //

/**
* Sets the symbol.
*
* @private
* @param {string} symbol - symbol
* @throws {TypeError} must be a supported symbol
*/
function set( symbol ) {
	/* eslint-disable no-invalid-this */
	if ( indexOf( SYMBOLS, symbol ) === -1 ) {
		throw new TypeError( 'invalid value. `symbol` must be a supported symbol. Symbols: ['+SYMBOLS.join(',')+']. Value: `'+symbol+'`.' );
	}
	debug( 'Current value: %d.', this._symbol );

	this._symbol = symbol;
	debug( 'New Value: %d.', this._symbol );

	this.emit( 'change' );
}


// EXPORTS //
export default set;
